import { Component } from '@angular/core';

@Component({
  selector: 'job-status-landing',
  templateUrl: './job-status-landing.component.html'
})
export class JobStatusLandingComponent {}
